/* Sisstr custom: blog carousel + gallery init, formerly injected inside theme.js. Ported 2026-07. */
(function () {
  function initArticle() {
    if (jQuery('.template-article .blog-carousel').length == 0)
      return;
    if (!jQuery.fn.slick) return;
    jQuery('.blog-carousel').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      dots: false,
      arrows: true
    });
  }

  function initSisstrsArticle() {
    if (jQuery('.template-article .gallery').length == 0)
      return;
    if (jQuery.fn.fancybox) {
      jQuery("[rel=fancybox-gallery]").fancybox();
      console.log('Fancybox loaded');
    }

    if (!jQuery.fn.masonry || !jQuery.fn.imagesLoaded) return;
		jQuery(".gallery").each(function() {
			let gallery = jQuery(this);
			var msnry = gallery.masonry({
				columnWidth: 'li',
				itemSelector: 'li'
			});
			msnry.imagesLoaded(function() {
				msnry.masonry();
			});
    });
        
  }

  function run() {
    if (!window.jQuery) return;
    initArticle();
    setTimeout(initSisstrsArticle, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
